import {
  StyledContent,
  StyledHeader,
  StyledList,
  StyledListItem,
  StyledListItemContent,
  StyledSubheader
} from './RegistrationLayout.style';
import {
  LinearBLogoNew,
  PremiumIcon,
  ProIcon,
  AppsAddIcon
} from '@linearb/linui-common';
import { Background } from '@linearb/linui-common/marketing/Background';
import { Grid, Hidden } from '@material-ui/core';
import {
  StyledGridContainer,
  StyledLogoContainer
} from 'views/login/Login.style';
import { Card } from '@linearb/linui-common/marketing/Card';
import { ReactNode } from 'react';

const listItems = [
  {
    content:
      'Get DORA metrics without limitations on contributors, users, or repos.',
    icon: PremiumIcon
  },
  {
    content:
      'Discover powerful productivity boosters from our Software Engineering Intelligence (SEI+) automation marketplace.',
    icon: AppsAddIcon
  },
  {
    content:
      'Take advantage of enterprise-grade integrations with assurance that your data is always safe and secure.',
    icon: ProIcon
  }
];

interface RegistrationLayoutProps {
  children: ReactNode;
}

/**
 * Registration layout component
 */
export const RegistrationLayout = ({ children }: RegistrationLayoutProps) => {
  return (
    <Background sx={{ height: '100vh', width: '100wv' }}>
      <StyledLogoContainer>
        <LinearBLogoNew />
      </StyledLogoContainer>

      <StyledGridContainer
        container
        justifyContent='center'
        alignItems='center'
      >
        {/* @ts-expect-error this is mistyped in MUI */}
        <Hidden mdDown>
          <Grid item lg={5} xl={4}>
            <StyledHeader>Create your free workspace</StyledHeader>

            <StyledSubheader>No credit card required.</StyledSubheader>

            <StyledList>
              {listItems.map(({ content, icon: Icon }, idx) => (
                <StyledListItem key={idx}>
                  <Icon color={'#865bff'} size={24} />
                  <StyledListItemContent>{content}</StyledListItemContent>
                </StyledListItem>
              ))}
            </StyledList>
          </Grid>
        </Hidden>

        <Grid item xl={4} lg={5} sm={8} xs={12}>
          <Card sx={{ padding: '41px 38px', margin: 3 }}>
            <StyledContent>{children}</StyledContent>
          </Card>
        </Grid>
      </StyledGridContainer>
    </Background>
  );
};
